export const ID = 'cf63d503-c4ff-4165-90d5-ed8e333f52d6';

export const NAME = 'Search Bar: Facilities';
